/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import moment from 'moment';
import BudgetApplicationForm from './BudgetApplicationForm';
import Attachments from './Attachments';
import ChangeRequestsTimeline from './ChangeRequestsTimeline';
import { actions as budgetActions } from '../../actions/budgetActions';
import approvalConstraints from '../../constants/approvalConstraints';
import { actions as authActions } from '../../actions/budgetAuthActions';
import UserInfoPanel from '../budgetAuth/UserInfoPanel';
import routePaths from '../../routePaths';
import ApplicationStatuses from './applicationStatuses';

class BudgetApplicationFormPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      approvalConstraintOption: null,
      gettingPdf: false,
      applicationId: null,
    };
    this.submitForm = this.submitForm.bind(this);
    this.handleDraftSave = this.handleDraftSave.bind(this);
    this.handleGetPdf = this.handleGetPdf.bind(this);
  }

  componentDidMount() {
    if (this.props.applicationFormId) {
      this.props.actions.loadBudgetWithMyApplication(this.props.applicationFormId);
    } else {
      this.props.actions.load();
    }
  }

  createFormInitialState() {
    const template = this.props.budget.applicationTemplate;
    const voterInitialState = {
      participantType: (template.voterRequiredData.naturalPersonEnabled && template.voterRequiredData.legalEntityEnabled) || (!template.voterRequiredData.naturalPersonEnabled && !template.voterRequiredData.legalEntityEnabled)
        ? null
        : template.voterRequiredData.naturalPersonEnabled ? 'naturalPerson' : 'legalEntity',
    };

    if (this.props.applicationFormId && this.props.applicationDraftData) {
      let draftData = Object.assign({}, this.props.applicationDraftData);
      if (!draftData.voter) {
        draftData.voter = voterInitialState;
      }
      return draftData;
    }

    return {
      budgetId: this.props.budget.id,
      form: !template.form ? [] : template.form.filter(d => d.type === 'text' || d.type === 'description').map(f => ({ id: f.id })),
      voter: voterInitialState,
    };
  }

  submitForm(data) {
    if (this.props.budget.applicationTemplate.approvals
      && this.props.budget.applicationTemplate.approvals.filter(a => a.appliesTo !== approvalConstraints.all.value).length
      && !this.state.approvalConstraintOption)
      return;

    if (this.props.userSignedIn && this.props.applicationFormId) {
      if (this.props.budget.application && 
          this.props.budget.application.changeRequests && 
          this.props.budget.application.changeRequests.some(req => req.status === 'requested')) {
        return this.props.actions.submitApplicationChanges(
          this.props.budget.id, 
          this.props.applicationFormId, 
          data
        );
      } else {
        return this.props.actions.submitDraftApplication(
          this.props.budget.id, 
          this.props.applicationFormId, 
          data
        );
      }
    }

    return this.props.actions.submitApplication(this.props.budget.id, data)
      .then(id => this.setState({ applicationId: id }));
  }

  handleDraftSave(data) {
    if (!this.props.userSignedIn) {
      return;
    }

    if (this.props.applicationFormId) {
      this.props.actions.updateDraftApplication(this.props.budget.id, this.props.applicationFormId, data);
    } else {
      this.props.actions.createDraftApplication(this.props.budget.id, data);
    }
  }

  handleGetPdf = params => {
    this.setState({ gettingPdf: true });
    this.props.actions.getReport(this.props.budget.id, this.props.applicationFormId, params)
      .finally(() => this.setState({ gettingPdf: false }));
  }

  render() {
    const { budget, unit, auth, userSignedIn, applicationFormId, canSubmit, showSaveDraftButton } = this.props;

    return (<React.Fragment>
      <div key="top" className="row top">
        <div className="col-sm-5 d-flex align-items-end">
          {!budget ? null :
            budget.applicationTemplate.voterRequiredData.authenticationRequired ?
              <span className="budget-menu-buttons">
                <a href={routePaths.myBudgetApplications} className="btn" aria-label='Moje projekty'>Moje projekty</a>
              </span> : null
          }
        </div>
        <div className="col-sm-7 header">
          <div className="budget-menu">
            {!budget ? null :
              budget.applicationTemplate.voterRequiredData.authenticationRequired || (auth && auth.signedIn) ?
                <UserInfoPanel auth={auth} authenticationRequired={budget.applicationTemplate.voterRequiredData.authenticationRequired}
                  authActions={this.props.authActions} account={this.props.account} /> : null
            }
            <a href="/budzet-obywatelski" className="btn"><i className="fa fa-long-arrow-alt-left" /> powrót</a>
          </div>
        </div>
      </div>
      {!budget ? <div style={{ width: '100%', marginTop: 200, textAlign: 'center' }}><CircularProgress size={50} /></div> :
        <div key="content" style={{ marginTop: 40 }}>
          <div className="row">
            <div className="box">
              <div className="col-sm-12">
                <h2>{budget.applicationTemplate.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: budget.applicationTemplate.description }} />

                {budget.applicationTemplate.descriptions && budget.applicationTemplate.descriptions.map(description => (
                  <div key={description.title} className="row inner-content">
                    <div className="col-xs-12 wrapper">
                      <h3>{description.title}</h3>
                      <div dangerouslySetInnerHTML={{ __html: description.description }} />
                    </div>
                  </div>)
                )}

                {(budget.applicationTemplate.voterRequiredData && budget.applicationTemplate.voterRequiredData.authenticationRequired && !userSignedIn)
                  || !canSubmit
                  ? <React.Fragment>
                    <Typography variant="subtitle2" component="p" color="primary">
                      {budget.applicationTemplate.voterRequiredData && budget.applicationTemplate.voterRequiredData.authenticationRequired && !userSignedIn
                        ? `Zgłoszenie projektu jest dostępne tylko dla zalogowanych użytkowników` : null}
                      {!canSubmit ?
                        budget.currentStage !== 2 || !budget.isActive
                          ? 'Aktualny etap budżetu nie pozwala na złożenie projektu'
                          : 'Aktualny status projektu nie pozwala na jego edycję'
                        : null}
                    </Typography>
                  </React.Fragment>
                  : null}
              </div>
            </div>
          </div>

          {budget.application && budget.application.changeRequests && budget.application.changeRequests.length > 0 && (
            <div className="row">
              <div className="box">
                <div className="col-sm-12">
                  <ChangeRequestsTimeline changeRequests={budget.application.changeRequests} />
                </div>
              </div>
            </div>
          )}

          {!budget.applicationTemplate.attachments || !budget.applicationTemplate.attachments.length ? null :
            <Attachments
              attachments={budget.applicationTemplate.attachments}
              unit={unit}
            />}

          <BudgetApplicationForm
            applicationForm={budget.applicationTemplate}
            onSubmit={this.submitForm}
            initialValues={this.createFormInitialState()}
            disabled={this.props.preview}
            unit={unit}
            approvalConstraintOption={this.state.approvalConstraintOption}
            onApprovalConstraintPick={type => this.setState({ approvalConstraintOption: type })}
            budget={budget}
            parcelsAutocompletion={budget.parcelsAutocompletionEnabled}
            readonly={(budget.applicationTemplate.voterRequiredData.authenticationRequired && !userSignedIn) || !canSubmit}
            handleDraftSave={this.handleDraftSave}
            onGetPdfReport={this.handleGetPdf}
            gettingPdf={this.state.gettingPdf}
            showGetPdfButton={!!applicationFormId}
            canSubmit={canSubmit}
            showSaveDraftButton={showSaveDraftButton}
          />
          <Dialog open={this.props.success} aria-labelledby="dialog-title" maxWidth="md">
            <DialogTitle id="dialog-title">Dziękujemy za zgłoszony projekt!</DialogTitle>
            <DialogContent>
              <p>Projekt w kolejnym etapie zostanie poddany weryfikacji.<br />
              Prosimy o śledzenie etapów zgodnie z harmonogramem.</p>
              {budget.applicationTemplate.eListOfSupportEnabled
                ? <React.Fragment>
                    <p>
                      Link umożliwiający zgłoszenie poparcia dla projektu<br />
                      <code>https://{window.location.host}/budzet/lista-poparcia/{this.state.applicationId}</code><br />
                    </p>
                    <p>
                      Zgłoszenie poparcia możliwe jest w terminie<br />
                      od <strong>{moment(budget.applicationTemplate.eListOfSupport.startDate).format('YYYY-MM-DD HH:mm')}</strong> do <strong>{moment(budget.applicationTemplate.eListOfSupport.endDate).format('YYYY-MM-DD HH:mm')}</strong>
                    </p>
                  </React.Fragment>
                : null}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { window.location.href = 'https://' + window.location.host; }} color="primary" variant="contained">
                Ok
            </Button>
            </DialogActions>
          </Dialog>
        </div>}
    </React.Fragment>);
  }
}

BudgetApplicationFormPage.propTypes = {
  applicationForm: PropTypes.object,
  actions: PropTypes.object.isRequired,
  budget: PropTypes.object,
  preview: PropTypes.bool,
  cms: PropTypes.object.isRequired,
  success: PropTypes.bool,
  unit: PropTypes.object.isRequired,
  auth: PropTypes.object,
  authActions: PropTypes.object.isRequired,
  account: PropTypes.object,
  userSignedIn: PropTypes.bool,
  applicationFormId: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const applicationFormId = ownProps.match.path === routePaths.budgetSavedApplication ? ownProps.match.params.id : '';

  // Helper function to check if there are active change requests
  const hasActiveChangeRequests = (application) => {
    return application && 
           application.changeRequests && 
           application.changeRequests.length > 0 && 
           application.changeRequests.some(req => req.status === 'requested');
  };

  return {
    applicationForm: state.form.applicationForm ? state.form.applicationForm.values : null,
    budget: state.budget.current,
    success: state.budget.success,
    preview: window.location.href.includes('podglad'),
    cms: state.cms,
    unit: state.unit,
    auth: state.budgetAuth,
    account: state.budgetAccount.data,
    userSignedIn: state.budgetAuth.signedIn,
    applicationFormId: applicationFormId,
    applicationDraftData: state.budget.current ? state.budget.current.application : null,
    canSubmit: state.budget.current ?
      ((state.budget.current.currentStage == 2 || state.budget.current.currentStage == 3) && state.budget.current.isActive &&
        ((!state.budget.current.application || state.budget.current.application.status == ApplicationStatuses.draft.value) || 
         hasActiveChangeRequests(state.budget.current.application)) && (!state.budget.current.application || state.budget.current.application.canSubmitChanges))
      : false,
    showSaveDraftButton: state.budget && state.budget.current && state.budget.current.applicationTemplate
      && state.budget.current.applicationTemplate.voterRequiredData && state.budget.current.applicationTemplate.voterRequiredData.authenticationRequired
      && (!state.budget.current.application || state.budget.current.application.status == ApplicationStatuses.draft.value)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(budgetActions, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetApplicationFormPage);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetApplicationFormPage.js